import { useCallback, useEffect, useRef, useState } from 'react';

export function useAmbientSound() {
  const contextRef = useRef<AudioContext | null>(null);
  const nodesRef = useRef<OscillatorNode[]>([]);
  const [enabled, setEnabled] = useState(false);

  const stop = useCallback(() => {
    for (const node of nodesRef.current) node.stop();
    nodesRef.current = [];
    void contextRef.current?.close();
    contextRef.current = null;
    setEnabled(false);
  }, []);

  const start = useCallback(() => {
    if (enabled) {
      stop();
      return;
    }
    const AudioContextClass = window.AudioContext;
    const context = new AudioContextClass();
    const master = context.createGain();
    master.gain.setValueAtTime(0.018, context.currentTime);
    master.connect(context.destination);

    const filters = [73.42, 110];
    const oscillators = filters.map((frequency, index) => {
      const oscillator = context.createOscillator();
      const gain = context.createGain();
      oscillator.type = index === 0 ? 'sine' : 'triangle';
      oscillator.frequency.setValueAtTime(frequency, context.currentTime);
      gain.gain.setValueAtTime(index === 0 ? 0.7 : 0.12, context.currentTime);
      oscillator.connect(gain).connect(master);
      oscillator.start();
      return oscillator;
    });

    contextRef.current = context;
    nodesRef.current = oscillators;
    setEnabled(true);
  }, [enabled, stop]);

  useEffect(() => stop, [stop]);

  return { enabled, toggle: start };
}
